import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import getBorderFocusStyles from '../../getBorderFocusStyles';
import SplitButton from '../../../../components/SplitButton/SplitButton';
var splitButtonStyles = {
  button: function button(_ref) {
    var v = _ref.variables;
    return {
      border: 0,
      padding: v.padding,
      ':focus-visible': {
        '::before': {
          border: 0
        },
        '::after': {
          border: 0
        }
      },
      ':active': {
        backgroundColor: v.backgroundColorActive
      }
    };
  },
  root: function root(_ref2) {
    var _Object$assign, _ref3;

    var p = _ref2.props,
        v = _ref2.variables,
        siteVariables = _ref2.theme.siteVariables;
    var borderWidth = siteVariables.borderWidth;
    var borderFocusStyles = getBorderFocusStyles({
      siteVariables: siteVariables
    });
    return _ref3 = {
      border: "".concat(borderWidth, " solid ").concat(v.borderColor),
      borderRadius: v.borderRadius,
      position: 'relative',
      display: 'inline-block'
    }, _defineProperty(_ref3, "& .".concat(SplitButton.slotClassNames.toggleButton), {
      borderRight: 0,
      borderTop: 0,
      borderBottom: 0
    }), _defineProperty(_ref3, ':focus-within', Object.assign({
      boxShadow: 'none'
    }, p.isFromKeyboard ? Object.assign((_Object$assign = {}, _defineProperty(_Object$assign, "& .".concat(SplitButton.slotClassNames.toggleButton), {
      color: p.primary ? v.primaryColorFocus : v.colorFocus,
      backgroundColor: p.primary ? v.primaryBackgroundColorFocus : v.backgroundColorFocus,
      borderColor: siteVariables.colors.white
    }), _defineProperty(_Object$assign, "color", v.colorFocus), _defineProperty(_Object$assign, "backgroundColor", v.backgroundColorFocus), _Object$assign), borderFocusStyles[':focus-visible']) : {
      ':active': {
        backgroundColor: v.backgroundColorActive
      }
    })), _ref3;
  }
};
export default splitButtonStyles;